<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Upload de Arquivos</p>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="crie" label="CRIE PRODUTOS POR PLANILHA" />
      <q-tab name="atualize" label="ATUALIZE PRODUTOS POR PLANILHA" />
      <q-tab name="remova" label="REMOVA ITENS DO CATÁLOGO" />
      <q-tab name="zerar" label="ZERAR PONTOS DE REPOSIÇÃO DOS ITENS" />
      <q-tab name="desativar" label="DESATIVAR CONTROLE DE LOTE" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="crie">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIE PRODUTOS POR PLANILHA
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosCrie"
          :showUnidade="false"
          :activeSlide="activeSlide"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />

        <upload
          :mapeamento="'produto'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx'"
          title="CRIE PRODUTOS POR PLANILHA"
        />
      </q-tab-panel>

      <q-tab-panel name="atualize">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ATUALIZE PRODUTOS POR PLANILHA
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosAtualize"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />
        <upload
          :mapeamento="mapeamentoAtualizacao"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx'"
          title="ATUALIZE PRODUTOS POR PLANILHA"
        />
      </q-tab-panel>

      <q-tab-panel name="remova">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            REMOVA ITENS DO CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosRemova"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_remover_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide3"
        />
        <upload
          :mapeamento="'delete_produto'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_remover_r0.xlsx'"
          title="REMOVA ITENS DO CATÁLOGO"
        />
      </q-tab-panel>

      <q-tab-panel name="zerar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ZERAR PONTOS DE REPOSIÇÃO DOS ITENS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosZerar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide4"
        />

        <upload
          :mapeamento="'zerar_limites_produto'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx'"
          title="ZERAR PONTOS DE REPOSIÇÃO DOS ITENS"
        />
      </q-tab-panel>

      <q-tab-panel name="desativar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            DESATIVAR CONTROLE DE LOTE
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide5 = !activeSlide5"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosDesativar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide5"
        />

        <upload
          :mapeamento="'desativacao_lote'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx'"
          title="DESATIVAR CONTROLE DE LOTE"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import InfotUpload from "../../compras/components/InfotUpload.vue";
import Upload from "../components/Upload.vue";
import { ref, computed } from "@vue/reactivity";
import { useStore } from "vuex";

export default {
  components: { Upload, InfotUpload },

  setup() {
    const store = useStore();
    
    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const activeSlide5 = ref(false);

    const mapeamentoAtualizacao = computed(() => {
      const cliente = store.state.autenticacao.cliente || '';
      const isAcciona = cliente.includes('acciona') || cliente.includes('staging-acciona');
      return isAcciona ? 'produto_edicao_acciona' : 'produto';
    });

    const infosCrie = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosAtualize = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosRemova = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "Verifique que o saldo do material está zerado para que a remoção seja bem sucedida",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosZerar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosDesativar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      activeSlide5,
      infosCrie,
      infosAtualize,
      infosRemova,
      infosZerar,
      infosDesativar,
      mapeamentoAtualizacao,
      tab: ref("crie"),
    };
  },
};
</script>

<style></style>
